if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      buyAreaVisible = true;
      cartOpen = false;

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.mainBtn = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.stickyBtn = this.querySelector('[data-sticky-atc-btn]');
        this.stickyBtnSpan = this.stickyBtn?.querySelector('span');
        this.priceEl = this.querySelector('[data-sticky-atc-price]');
        this.imgEl = this.querySelector('[data-sticky-atc-img]');

        if (!this.mainBtn || !this.stickyBtn) return;

        this.watchBuyArea();
        this.watchCartDrawer();

        this.unsubscribeVariant = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.onVariantChange.bind(this)
        );

        this.stickyBtn.addEventListener('click', () => this.mainBtn.click());
      }

      disconnectedCallback() {
        this.buyObserver?.disconnect();
        this.cartObserver?.disconnect();
        this.unsubscribeVariant?.();
      }

      watchBuyArea() {
        const buyArea = document.getElementById(`buy-buttons-${this.sectionId}`);
        if (!buyArea) return;

        this.buyObserver = new IntersectionObserver(
          ([entry]) => {
            this.buyAreaVisible = entry.isIntersecting;
            this.updateVisibility();
          },
          { threshold: 0 }
        );
        this.buyObserver.observe(buyArea);
      }

      watchCartDrawer() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;

        this.cartObserver = new MutationObserver(() => {
          this.cartOpen = cartDrawer.classList.contains('active');
          this.updateVisibility();
        });
        this.cartObserver.observe(cartDrawer, {
          attributes: true,
          attributeFilter: ['class'],
        });
      }

      updateVisibility() {
        this.classList.toggle('sticky-atc--visible', !this.buyAreaVisible && !this.cartOpen);
      }

      onVariantChange({ data: { sectionId, variant } }) {
        if (sectionId !== this.sectionId) return;

        // Mirror button disabled state and text (product-info.js updates mainBtn before publishing this event)
        this.stickyBtn.disabled = this.mainBtn.hasAttribute('disabled');
        const mainSpanText = this.mainBtn.querySelector('span')?.textContent?.trim();
        if (mainSpanText && this.stickyBtnSpan) {
          this.stickyBtnSpan.textContent = mainSpanText;
        }

        // Mirror price from the already-updated price element
        const priceSource = document.querySelector(
          `#price-${this.sectionId} .price-item--regular, #price-${this.sectionId} .price-item--sale`
        );
        if (priceSource && this.priceEl) {
          this.priceEl.textContent = priceSource.textContent.trim();
        }

        // Update thumbnail to variant's featured media
        const imgSrc = variant?.featured_media?.preview_image?.src;
        if (imgSrc && this.imgEl) {
          this.imgEl.src = `${imgSrc}&width=80`;
          this.imgEl.alt = variant.featured_media.alt || '';
        }
      }
    }
  );
}
